import Message from "../Message";
import {createRef} from "react";
import ChatEventCodes from "../../utils/ChatEventCodes";

export default class FormComponent extends Message {
    constructor(props) {
        super(props);

        this.state = {
            /**
             * Boolean used to indicate to form components if the user has interacted,
             * and the form is validated, that the form should be hidden from the chat
             * context.
             */
            formSubmitted: false
        };

        /** @type {React.RefObject} */
        this.formRef = createRef();
        /** @type {`${string}-${string}-${string}-${string}-${string}`} */
        this.formId = crypto.randomUUID();
        /** @type {Function} */
        this.submitForm = this.submitForm.bind(this);
    }

    /**
     * Handles a generic form submission for the chat's form messages. This creates a new object on
     * which the form data is genereated using the target form's key/value pairs of inputs. If any form
     * keys are optional, then they should be preceeded by an empty and hidden input to satisfy the
     * vendor requirements of all keys being present.
     *
     * This then dispatches an event to chat-bot.jsx to get the form data and send it to the
     * web socket henalder to send it as a message.
     * @param {SubmitEvent} e The submit event from pressing the form's submit button. This will be
     * superceeded by and failing validation on the browser side before reaching this function.
     */
    submitForm(e) {
        const formData = new FormData(e.currentTarget);
        const messageObject = {
            formData: {},
            submitAndClose: e.currentTarget.dataset.submitAndClose === 'true'
        };
        formData.forEach((value, key) => messageObject.formData[key] = value);
        console.log(messageObject);
        e.preventDefault();
        this.setState({formSubmitted: true}, () => {
            document.dispatchEvent(new MessageEvent(ChatEventCodes.FormSubmitted, {data: messageObject}));
        });
    }
}